<template>
    <el-button size="small"
               :disabled="disabled"
               @click="changeState">
        <span class="icon-wrapper">
            <i class="fas fa-arrows-alt-h" style="font-size: 1.2em;"
               v-if="state === 0"></i>
            <i class="fas fa-arrow-left"
               v-if="state === 1"></i>
            <i class="fas fa-arrow-right"
               v-if="state === 2"></i>
        </span>
    </el-button>
</template>

<script>
export default {
    props: {
        initialState: {
            type: Number,
            default: 1, // Bi-directional as default
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        allowedStates: {
            type: Array,
            default: () => [1, 2, 3] // By default, all states are allowed
        }
    },
    data() {
        return {
            state: (this.initialState - 1),
        }
    },
    watch: {
        initialState(newValue) {
            if (newValue - 1 !== this.state) {
                this.state = newValue - 1
            }
        }
    },
    methods: {
        changeState() {
            // Find the next allowed state
            let nextState;
            let currentIndex = this.allowedStates.indexOf(this.state + 1);

            if (currentIndex === -1 || currentIndex === this.allowedStates.length - 1) {
                nextState = this.allowedStates[0] - 1;
            } else {
                nextState = this.allowedStates[currentIndex + 1] - 1;
            }

            this.state = nextState;
            this.$emit('change', this.state + 1);
        },
    },
}
</script>

<style scoped>
.icon-wrapper {
    display: inline-block;
    width: 1.2em;
    height: 1.2em;
    line-height: 1.2em;
    text-align: center;
}
</style>
